var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"textline",staticClass:"text-line",class:[
    { 'text-line--underlined' : _vm.underlined },
    { 'text-line--uppercase' : _vm.uppercase },
    { 'text-line--visible' : _vm.visible } ]},[_vm._v(" "+_vm._s(_vm.line)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }